import { Files } from '../../lib/constants/files'
import { FileInput } from '../../lib/types/models/file/file-input'
import { TripAddressInput } from '../../lib/types/models/trip-address/trip-address-input'
import { UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateTripAddress(data: UpdateInput<TripAddressInput>) {
  const { id, pictures: picturesToUpload, ...rest } = data

  const pictures: FileInput[] = []

  for (const picture of picturesToUpload ?? []) {
    const s3Picture = await uploadFile(Files.TRIP_ADDRESS_PICTURES, picture)
    if (s3Picture) pictures.push(s3Picture)
  }

  return restApiClient
    .url(constructApiUrl(API.tripAddresses.update.url, { id }))
    .patch({ ...rest, pictures })
}
